import { Block, Box, ListItem } from '@rulebooks/evidend-titan';
import { formatDirectorAuthority, formatRepresentationAuthority } from 'helpers/directors';
import type { SummaryCardsComponentProps } from 'helpers/formatMutation';
import React from 'react';
import { ShareholderCapitalCard } from 'summaries/CapitalCards/ShareholderCapitalCard';
import { DeedCard } from 'summaries/DeedCard/DeedCard';

export const AppointDirectorSummaryCards = ({
  backgroundVariant = 'white',
  mutation,
  onDocumentSave,
}: SummaryCardsComponentProps) => {
  const directors = mutation.appointDirector || [];

  return (
    <>
      {!!directors.length && (
        <Box spaceAfter={10}>
          {directors.map((director) => (
            <ShareholderCapitalCard
              key={director.id}
              backgroundVariant={backgroundVariant}
              party={director.director}
            >
              {director.title && <ListItem prefixAdornment="•">{director.title}</ListItem>}
              <ListItem prefixAdornment="•">{formatDirectorAuthority(director.authority)}</ListItem>
              <ListItem prefixAdornment="•">
                {formatRepresentationAuthority(director.representationAuthority)}
              </ListItem>
            </ShareholderCapitalCard>
          ))}
        </Box>
      )}

      {mutation.document && (
        <Block spaceAfter={10}>
          <DeedCard
            backgroundVariant={backgroundVariant}
            document={mutation.document}
            mutation={mutation}
            onDocumentSave={onDocumentSave}
          />
        </Block>
      )}
    </>
  );
};
